/** The world's phone readers, from `@libs/countries-contracts/world` (LIS-1173), for this
 *  package's current callers. */
export {
  diallingCode,
  displayPhone,
  nationalPhone,
  phoneParts,
  readPhone,
  type DialledPhone,
} from "@libs/countries-contracts/world";
